import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./InfoPanel.css";

const InfoPanel = ({ children, className }) => (
	<div className={classNames("Info-Panel", className)}>
		{children}
	</div>
);

InfoPanel.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element
	]),
	className: PropTypes.string
};

export default InfoPanel;
